export default [
  {
    path: '/feedbackIndex',
    name: 'feedbackIndex',
    component: () => import('@/views/feedbackSystem/index'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/feedbackVivw',
    name: 'feedbackVivw',
    component: ()=> import('@/views/feedbackSystem/vivw'),
    meta: {
      title: '详情'
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/feedbackRouter.js